const alterConfig = (config, alter) => {
  config = alter(config) || config
  if(_.isPlainObject(config)) {
    return Object.keys(config).reduce((adjusted, key) => ({
      ...adjusted,
      [key]: alterConfig(config[key], alter)
    }), {})
  } 
  if(_.isArray(config)) {
    return config.map(value => alterConfig(value, alter))
  }
  return config
}

export default alterConfig